import { useCallback } from "react";
import { getApiErrorMessage, postPhoneCallLog } from "../api/phoneApi";

export const usePhoneCallLogger = ({ getAccessToken }) => {
  const logCallEvent = useCallback(
    async (event, metadata = {}, options = {}) => {
      const { required = false } = options;

      try {
        const accessToken = await getAccessToken();
        return await postPhoneCallLog(accessToken, {
          event,
          ...metadata,
        });
      } catch (logError) {
        const message = getApiErrorMessage(
          logError,
          "Unable to log phone event."
        );

        if (required) {
          throw new Error(message);
        }

        console.warn("Unable to log phone event", logError);
        return null;
      }
    },
    [getAccessToken]
  );

  return { logCallEvent };
};
